class TSCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerTrigger = document.querySelector("#TSCartTrigger");
    this.isLoading = false;

    if (this.cartDrawerTrigger) {
      this.cartDrawerTrigger.addEventListener("click", () => {
        this.open();
      })
    }

    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        const item = e.target.closest("[data-line]");
        const line = item ? item.dataset.line : false;

        switch (e.target.dataset.trigger) {
          case "close":
            this.close();
            break;
          case "delete":
            if (this.isLoading) break;
            this.updateQuanity(line, 0);
            break;
          case "quantity":
            if (this.isLoading) break;
            let quantity = parseInt(item.querySelector('input[name="quantity"]').value);

            if (e.target.hasAttribute("data-plus")) {
              quantity += 1;
            } else if (e.target.hasAttribute("data-minus")) {
              quantity -= 1;
            }
            this.updateQuanity(line, quantity);
            break;
          case "upsell-add":
            if (this.isLoading) break;
            const upsellProductItem = e.target.closest("[data-variant]");
            this.addUpsellItem(parseInt(upsellProductItem.dataset.variant));
            break;
        }
      }
    })
  }

  updateQuanity(line, quantity) {
    this.toggleLoading();
    const data = {
      line: `${line}`,
      quantity: `${quantity}`,
      sections: ["header", "main-cart"],
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      // Dispatch cart:update event for subscription apps
      const cartUpdateEvent = new CustomEvent('cart:update', { 
        detail: response,
        bubbles: true 
      });
      document.dispatchEvent(cartUpdateEvent);
      
      this.renderContent(response.sections, response);
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(this.toggleLoading.bind(this));
  }

  addUpsellItem(upsellProduct) {
    this.toggleLoading();
    const sections = ["header", "main-cart"];
    const cartData = {
      items: [
        {
          id: upsellProduct,
          quantity: 1
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        let error = new Error(response.description);
        throw error;
      } else {
        // Dispatch ajaxProduct:added event for subscription apps
        const ajaxProductEvent = new CustomEvent('ajaxProduct:added', {
          detail: response,
          bubbles: true
        });
        document.dispatchEvent(ajaxProductEvent);
        
        this.renderContent(response.sections, response);
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(this.toggleLoading.bind(this));
  }
 
  renderContent(sections, responseJson = null) {
    const headerHtml = new DOMParser().parseFromString(sections['header'], "text/html");
    const mainCartHtml = sections['main-cart'] 
      ? new DOMParser().parseFromString(sections['main-cart'], "text/html")
      : null;

    // Update cart trigger
    const cartTrigger = document.querySelector("#TSCartTrigger");
    const newCartTrigger = headerHtml.querySelector("#TSCartTrigger");
    if (cartTrigger && newCartTrigger) {
      // Preserve existing classes, only toggle has-blip-visible
      cartTrigger.classList.toggle("has-blip-visible", newCartTrigger.classList.contains("has-blip-visible"));
    }

    // Update TS Cart Drawer content
    const tsCartInner = this.querySelector(".ts-cart__inner");
    const newTsCartInner = headerHtml.querySelector("ts-cart .ts-cart__inner");
    
    if (tsCartInner && newTsCartInner) {
      // Preserve existing classes on ts-cart element
      const existingClasses = Array.from(this.classList);
      
      // Update inner content
      tsCartInner.innerHTML = newTsCartInner.innerHTML;
      
      // Restore classes (preserve all existing classes)
      existingClasses.forEach(className => {
        this.classList.add(className);
      });
    }

    // Re-execute any scripts that were cloned (basic script re-initialization)
    const scripts = this.querySelectorAll('script');
    scripts.forEach(oldScript => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      if (oldScript.parentNode) {
        oldScript.parentNode.replaceChild(newScript, oldScript);
      }
    });

    this.open();
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("ts-cart", TSCartDrawer);